import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function generateUniquePlayerKey(
  imageArray: { key: string }[],
  baseKey: string
): string {
  const existingKeys = new Set(imageArray.map((img) => img.key))
  const baseMatch = baseKey.match(/^(.*?)(?:_(\d+))?$/)

  if (!baseMatch) return baseKey

  const baseName = baseMatch[1]
  let counter = baseMatch[2] ? parseInt(baseMatch[2]) + 1 : 1

  let newKey = baseKey
  while (existingKeys.has(newKey)) {
    newKey = `${baseName}_${counter}`
    counter++
  }

  return newKey
}

export const clearAllChat = () => {
  return Object.keys(localStorage).forEach((key: string) => {
    if (key.includes('chat_interface_state')) {
      localStorage.removeItem(key)
    }
  })
}
